import {ColumnDef, createColumnHelper} from '@tanstack/react-table'
import {FC, useEffect, useMemo, useState} from 'react'
import useAxiosPrivate from '../../../../libs/useAxiosPrivate'
import DataTable from '../../../../../ui-kit/DataTable/DataTable'
import {Link} from 'react-router-dom'
import {showSwal} from '../../../../../ui-kit'
import {deleteTariffByTypeAndID} from '../core/_requests'

interface DataRow {
  id: number
  hs: string
  hs_description: string
  ave_max: number
}

type ListBoundTariffTableProps = {
  data: Array<DataRow>
  isLoading: boolean
}

const columnHelper = createColumnHelper<DataRow>()



const ListBoundTariffTable: FC<ListBoundTariffTableProps> = ({data = [], isLoading}) => {
  const [dataTable, setDataTable] = useState<DataRow[]>([])

  useEffect(() => {
    if (data.length > 0) {
      setDataTable(data)
    }
  }, [data])

  const columns: ColumnDef<DataRow, any>[] = useMemo(
    () => [
      columnHelper.accessor('hs', {
        header: 'Commodity',
        cell: (info) => <span className='badge text-white bg-dark'>{info.getValue()}</span>,
        meta: {
          headerClass: 'w-100px text-center',
          cellClass: 'text-center',
        },
        enableSorting: true,
        enableGlobalFilter: true,
      }),
      columnHelper.accessor('hs_description', {
        header: 'Description',
        cell: (info) => info.getValue(),
        meta: {
          headerClass: '',
          cellClass: '',
        },
        enableSorting: true,
        enableGlobalFilter: true,
      }),
      columnHelper.accessor('ave_max', {
        header: 'Tariff',
        cell: (info) => `${Math.round(info.getValue())}%`,
        meta: {
          cellClass: 'text-end',
          headerClass: 'font-bold',
        },
        enableSorting: true,
        enableGlobalFilter: true,
      }),
      columnHelper.accessor('id', {
        header: 'Actions',
        cell: (info) => (
          <div className='d-flex gap-3 justify-content-center'>
            <Link to={`/tariff/${'bound'}/${encodeURIComponent(info.getValue() || '')}`}>
              <span className='fa fa-eye'></span>
            </Link>
            <Link to='#' className='link-danger' onClick={() => handleDelete(info.getValue())}>
              <span className='fa fa-trash'></span>
            </Link>
          </div>
        ),
        meta: {
          cellClass: 'text-center',
          headerClass: 'font-bold',
        },
        enableSorting: false,
        enableGlobalFilter: false,
      }),
    ],
    []
  )

  const axiosPrivate = useAxiosPrivate()

  const handleDelete = (id: any) => {
    showSwal({
      title: 'Are you sure you want to delete this Bound Tariff?',
      icon: 'question',
    }).then((result) => {
      if (!result.isConfirmed) return

      deleteTariffByTypeAndID(axiosPrivate, 'bound', id).then((res) => {
        if (res.status === 200) {
          showSwal('Bound Tariff deleted', undefined, 'success').then(() => setDataTable((prev) => prev.filter((row) => row.id !== id)))
        }
      })
    })
  }

  return (
    <>
      <DataTable<DataRow>
        data={dataTable}
        columns={columns}
        isLoading={isLoading}
        enablePagination={true}
        enableSorting={true}
        enableGlobalFilter={true}
        globalFilterPlaceholder=''
        defaultPageSize={20}
        pageSizes={[5, 10, 20, 50, 100]}
        className='my-custom-table-wrapper'
        initialSortBy={{id: 'hs', desc: false}}
      />
    </>
  )
}

export default ListBoundTariffTable
